import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

import { getDynamicDashboardPath } from 'config';
import useFunnerInternalAccess from 'hooks/useFunnerInternalAccess';
import Loader from 'ui-component/Loader';
import { GuardProps } from 'types';

type FunnerInternalGuardProps = GuardProps & {
  /** ברירת מחדל: דף הבית. לסנכרון קריאות שירות — חזרה להגדרות פריוריטי. */
  redirectTo?: string;
};

// ==============================|| FUNNER INTERNAL GUARD ||============================== //

/**
 * Restricts a route to Funner internal company only
 * (`VITE_APP_FUNNER_COMPANY_ID` / default Funner company GUID).
 */
export default function FunnerInternalGuard({ children, redirectTo }: FunnerInternalGuardProps) {
  const { isLoaded, isSignedIn } = useAuth();
  const { isReady, isAllowed } = useFunnerInternalAccess();

  if (!isLoaded) {
    return <Loader />;
  }

  if (isSignedIn === false) {
    return <Navigate to="/login" replace />;
  }

  if (!isReady) {
    return <Loader />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectTo ?? getDynamicDashboardPath()} replace />;
  }

  return children;
}
